import { observer } from "mobx-react-lite";
import {
  MyButton,
  MyCheckBox,
  MyInput,
  MyModal,
} from "../../../components/Commons";
import { COMMON } from "../../../constants/commonText.constants";
import { useTran } from "../../../hooks/useTran";
import { useCompanyStore } from "../hooks/useCompanyStore";
import { COMPANY } from "../constants/companyText.constants";

const DuplicateCompanyModal = observer(() => {
  const { t } = useTran();
  const {
    duplicateCompanyForm,
    duplicateErrors,
    isDuplicateCompanyModalOpen,
    isDuplicateCompanySubmitting,
    closeDuplicateCompanyModal,
    setDuplicateCompanyFormValue,
    duplicateCompany,
  } = useCompanyStore();

  const _handleClose = () => {
    if (isDuplicateCompanySubmitting) return;
    closeDuplicateCompanyModal();
  };

  const _handleDuplicate = async () => {
    await duplicateCompany();
  };

  return (
    <MyModal
      isOpen={isDuplicateCompanyModalOpen}
      onClose={_handleClose}
      title={t(COMPANY.DUPLICATE_COMPANY)}
      isStatic
      footer={
        <div className="flex gap-2 items-center justify-end">
          <MyButton
            variant="secondary"
            onClick={_handleClose}
            disabled={isDuplicateCompanySubmitting}
          >
            {t(COMMON.CANCEL)}
          </MyButton>
          <MyButton
            loading={isDuplicateCompanySubmitting}
            onClick={_handleDuplicate}
          >
            {t(COMPANY.DUPLICATE_COMPANY)}
          </MyButton>
        </div>
      }
    >
      <div className="space-y-4">
        <MyInput
          id="companyName"
          label={t("Company Name")}
          placeholder={t("Company Name")}
          value={duplicateCompanyForm.companyName}
          onChange={setDuplicateCompanyFormValue}
          error={duplicateErrors.companyName}
        />
        <label className="flex items-center gap-3">
          <MyCheckBox
            id="includeData"
            checked={duplicateCompanyForm.includeData}
            onChange={setDuplicateCompanyFormValue}
          />
          <span className="text-sm text-gray-700">
            {t(COMPANY.INCLUDE_COMPANY_DATA)}
          </span>
        </label>
      </div>
    </MyModal>
  );
});

export default DuplicateCompanyModal;
